const mobileLanguageMenu = document.getElementById("mobile-navigation-list-dropdown");
const currentUrl = window.location.href;
const urlObj = new URL(currentUrl);
const currentPathname = urlObj.pathname;
const currentSearch = urlObj.search;

function generateLanguageLink(lang) {
  if (currentPathname === "/templates/search") {
    if (urlObj.hostname === "localhost" || urlObj.hostname.startsWith("127.0.0.")) {
      return `${urlObj.origin}${currentPathname}?lang=${lang}`;
    } else {
      const domain = urlObj.hostname.replace(/^(en\.|ua\.|ru\.|es\.|br\.|fr\.|de\.|tr\.)/, "");
      let newHost;
      if (lang === "en") {
        newHost = domain;
      } else {
        newHost = `${lang}.${domain}`;
      }
      return `${urlObj.protocol}//${newHost}${currentPathname}?lang=${lang}`;
    }
  } else if (urlObj.hostname === "localhost" || urlObj.hostname.startsWith("127.0.0.")) {
    return `${urlObj.origin}${currentPathname}?lang=${lang}`;
  } else {
    const domain = urlObj.hostname.replace(/^(en\.|ua\.|ru\.|es\.|br\.|fr\.|de\.|tr\.)/, "");
    let newHost;
    if (lang === "en") {
      newHost = domain;
    } else {
      newHost = `${lang}.${domain}`;
    }
    return `${urlObj.protocol}//${newHost}${currentPathname}${currentSearch}`;
  }
}

const languageItems = Array.from(mobileLanguageMenu.querySelectorAll("li"));
mobileLanguageMenu.innerHTML = "";

const midPoint = Math.ceil(languageItems.length / 2);
const firstColumnItems = languageItems.slice(0, midPoint);
const secondColumnItems = languageItems.slice(midPoint);

const firstColumnUl = document.createElement("ul");
firstColumnUl.classList.add("mobile-language-column");
firstColumnItems.forEach(item => firstColumnUl.appendChild(item));

const secondColumnUl = document.createElement("ul");
secondColumnUl.classList.add("mobile-language-column");
secondColumnItems.forEach(item => secondColumnUl.appendChild(item));

const menuLine = document.createElement("div");
menuLine.classList.add("lang-menu-line-mobile", "dropdown-li");

mobileLanguageMenu.style.display = "flex";
mobileLanguageMenu.style.justifyContent = "start";
mobileLanguageMenu.style.paddingLeft = "27px";
mobileLanguageMenu.style.paddingTop = "20px";

mobileLanguageMenu.appendChild(firstColumnUl);
mobileLanguageMenu.appendChild(menuLine);
mobileLanguageMenu.appendChild(secondColumnUl);


mobileLanguageMenu.querySelectorAll("a").forEach((link) => {
  const lang = link.dataset.lang;
  link.href = generateLanguageLink(lang);

  link.addEventListener("click", function (event) {
    event.preventDefault();
    window.location.href = this.href;
  });
});
